// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fdc54f5c","337":"4ddb50ee","455":"4f64f8de"}[chunkId] + ".chunk.js";
};